import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JournalApiService {

  constructor(private http: HttpClient) {}

  readonly journalsUrl: string = 'journal';

  public getJournals(params: any = {}): Observable<any> {
    params = UrlQueryService.restructureFilterParams(params);
    UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.journalsUrl, params);

    return this.http.get(url);
  }
}
